import Form from "react-bootstrap/Form";
import React, { useEffect, useState } from "react";
import { OverlayTrigger } from "react-bootstrap";
import { Tooltip } from "react-bootstrap";
import Offcanvas from "react-bootstrap/Offcanvas";
import NewWindowLogo from "assets/img/illustrations/NewWindowLogo";
import { useRewardsInfo } from "./store";
import CardDiv from "modules/common/card-div/CardDiv";

function OffCanvas({ name, ...props }) {
  const { coinHistoryData, fetchCoinHistory } = useRewardsInfo();
  const [show, setShow] = useState(false);
  const [totalCoins, setTotalCoins] = useState(0);
  const handleShow = () => {
    fetchCoinHistory(props?.userId);
    setShow(true);
  };

  const handleClose = () => {
    setTotalCoins(0);
    setShow(false);
  };

  useEffect(() => {
    const totalMapCoins = coinHistoryData?.data?.allRewards?.reduce(
      (prev, curr) => {
        const rewardValue = parseFloat(curr?.rewardInfo?.reward?.value);
        return isNaN(rewardValue) ? prev : prev + rewardValue;
      },
      0
    );
    setTotalCoins(totalMapCoins);
  }, [coinHistoryData]);

  return (
    <>
      <div variant="primary" className="me-2">
        <div className="d-flex ">
          <OverlayTrigger
            overlay={
              <Tooltip
                style={{ position: "fixed" }}
                id="overlay-trigger-example"
              >
                <div className="fw-bold"> Click to view Coin History</div>
              </Tooltip>
            }
          >
            <div className="pe-3" onClick={handleShow}>
              <NewWindowLogo />
              {props?.userName}
            </div>
          </OverlayTrigger>
        </div>
      </div>
      <Offcanvas
        show={show}
        onHide={handleClose}
        {...props}
        style={{ width: "30%" }}
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            <h3 className="text-break py-2 ">User Name: {props?.userName}</h3>
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div>
            <div className="">
              <div>
                <CardDiv
                  title={
                    <div className="fs-2 fw-bold">Wallet Coin Balance:</div>
                  }
                  component={
                    <div className="fs-2">
                      {coinHistoryData?.data?.coinBalance || 0}
                    </div>
                  }
                />
                <div className="mt-2">
                  <CardDiv
                    title={<div className="fs-2 fw-bold"> Claimed Coins:</div>}
                    component={
                      <div className="fs-2">
                        {coinHistoryData?.data?.claimedCoins || 0}
                      </div>
                    }
                  />
                </div>
                <div className="mt-2">
                  <CardDiv
                    title={
                      <div className="fs-2 fw-bold"> Total issued Coins:</div>
                    }
                    component={<div className="fs-2"> {totalCoins || 0}</div>}
                  />
                </div>
              </div>
            </div>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}

function UserRewardCanvas({ userName, userId }) {
  return (
    <>
      <OffCanvas
        key={6}
        userName={userName}
        userId={userId}
        placement={"end"}
        name={"Filter"}
      />
    </>
  );
}

export default UserRewardCanvas;
